import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'



import BoxSection from '../Layout/BoxSection'



import { 
    displayModalAddTiquete, 
    addFile,
    updateInputs
} from '../../actions/tiquetesaereo'


import { 
    displayModalAddFile, 
    updateInputs as updateInputsModalAddFile,
    downloadFile
} from '../../actions/common'


class Tiquetes extends Component {

	render() {
        
        const { id, tiquetesaereo } = this.props

        const estado = tiquetesaereo.get('estado')

        if (!id) return null

        const tipo_trayecto = tiquetesaereo.getIn(['viaje', 'tipo_trayecto'])
        
        return ( 
        <Fragment>

            <BoxSection title="Cierre de tiquetes">

                <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-trayectos">                                    
                    <thead>
                        <tr>
                            <th style={{ width: '25px', textAlign: 'center' }}>No.</th>
                            <th>Pasajero</th>
                            <th style={{ width: '10%' }}>No. Tiquete</th>
                            <th>Aerolínea/Proveedor</th>
                            <th style={{ width: '70%' }}>Trayectos</th>                            
                        </tr>
                    </thead>
                    <tbody>
                    {
                        (tiquetesaereo.getIn(['viaje', 'pasajeros']).count() > 0) &&
                            tiquetesaereo.getIn(['viaje', 'pasajeros']).map((x, n) => {

                                const pasajero = `${x.get('nombres')} ${x.get('apellidos')}`


                                //const hoy = new Date(2019, 5, 15)
                                const hoy = new Date() 

                                const expirados = x.getIn(['tiquete', 'itinerarios']).filter(i => moment(i.get('fecha_salida')) < moment(hoy))

                                return (                                        
                                    <tr key={ `tr[${n}]`}>
                                        <td className="text-right">{n+1}</td>
                                        <td>{ pasajero }</td>
                                        <td>{x.getIn(['tiquete', 'numero_tiquete'])}</td>
                                        <td>{x.getIn(['tiquete', 'aerolinea'])}</td>
                                        <td>
                                            <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-trayectos">
                                                <thead>
                                                    <tr>
                                                        <th>Orígen</th>
                                                        <th>Fecha salida</th>
                                                        <th>Destino</th>
                                                        {
                                                            (tipo_trayecto == 1) && (
                                                                <th>Fecha regreso</th>
                                                            )
                                                        }
                                                        <th>¿Se cumplió el viaje?</th>
                                                        <th>Observaciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        expirados.map((t,ti) => {
                                                            return(
                                                                <tr key={`ite[${n}][${ti}]`}>
                                                                    <td>{t.get('origen')}</td>
                                                                    <td>{ moment(t.get('fecha_salida')).format('DD/MM/YYYY hh:mm A') }</td>
                                                                    <td>{t.get('destino')}</td>
                                                                    {
                                                                        (tipo_trayecto == 1) && (
                                                                            <td>{ moment(t.get('fecha_llegada')).format('DD/MM/YYYY hh:mm A') }</td>
                                                                        )
                                                                    }

                                                                    {
                                                                        (estado < 7) ? (
                                                                            <td>
                                                                                <select className="form-control input-sm" value={ t.get('cumplido') == null ? "-1" : t.get('cumplido')  } onChange={ (e) => this.props.updateInputs(`solicitud.viaje.pasajeros.${n}.tiquete.itinerarios.${ti}.cumplido`, e.target.value) } disabled={ estado != 6 } >
                                                                                    <option value="-1" disabled>Seleccione una opción</option>
                                                                                    <option value="0">No cumplió</option>
                                                                                    <option value="1">Si cumplió</option>
                                                                                </select>
                                                                            </td>
                                                                        ) : (
                                                                            <td>
                                                                            {
                                                                                `${t.get('cumplido') == 1 ? 'Si cumplió' : 'No cumplió'}`
                                                                            }
                                                                            </td>
                                                                        )
                                                                    }

                                                                    {
                                                                        (estado < 7) ? (
                                                                            <td>
                                                                                <textarea rows={2} cols={20} className="form-control input-sm" value={ t.get('observaciones') || '' } onChange={ (e) => this.props.updateInputs(`solicitud.viaje.pasajeros.${n}.tiquete.itinerarios.${ti}.observaciones`, e.target.value) } disabled={ estado != 6 } />
                                                                            </td>
                                                                        ) : (
                                                                            <td style={{height: '50px'}}>{ t.get('observaciones') }</td>
                                                                        )
                                                                    }                                                        

                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>                                                
                                            </table>                                                
                                        </td>  

  
                                    </tr>
                                )                                    
                            })
                    }   
                    </tbody>
                </table>

            
            </BoxSection>




        </Fragment> 
        )
	}
}

function mapStateToProps(state) {
    return {
        id: state.tiquetesaereo.get('id'),
        tiquetesaereo: state.tiquetesaereo.get('solicitud')
    }
}

function mapDispatchToProps(dispatch) {
    return {
        displayModalAddTiquete: (show, title, index) => dispatch(displayModalAddTiquete(show, title, index)), 
        displayModalAddFile: (show, title, mode, index) => dispatch(displayModalAddFile(show, title, mode, index)),
        addFile: (path) => dispatch(addFile(path)), 
        downloadFile: (id, filename) => dispatch(downloadFile(id, filename)),
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Tiquetes)


// WEBPACK FOOTER //
// ./src/components/TiquetesAereos/Cierre.jsx